<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-container>
        <v-card-title>ADD A PROJECT CLIENT</v-card-title>
        <label>Clients</label>
        <v-autocomplete
          item-color="green"
          label="choose client"
          outlined
          v-model="clientData"
          :items="projectClientList"
          item-text="client_name"
          item-value="id"
        ></v-autocomplete>
        <v-card-actions>
          <v-btn rounded color="primary" @click="createClient">ADD</v-btn>
          <v-btn rounded color="secondary" @click="clearClient">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn>Add New Client</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";

export default {
  name: "ProjectClientAdd",
  props: ["addClient", "projectClientList"],
  data() {
    return {
      clientData: "",
    };
  },
  computed: {
    show: {
      get() {
        return this.addClient;
      },
      set(show) {
        this.$emit("update-add-client-modal", show);
      },
    },
  },
  methods: {
    ...mapActions([
      "CreateProjectClient",
      "showLoadingProcess",
      "closeLoading",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async createClient() {
      await this.showLoadingProcess();
      try {
        const data = {
          project_id: this.$route.query.project_id,
          client_id: this.clientData,
        };
        await this.CreateProjectClient(data);
        await this.closeLoading();
        await this.showSnackBar({
          text: "Description has be added to Project",
          color: DEFAULT_CONSTANTS.success,
        });
        this.clearClient();
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        console.log(err);
        this.clearClient();
        await this.showSnackBar({
          text: "Insert Failed",
          color: DEFAULT_CONSTANTS.error,
        });
        await this.closeLoading();
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },

    clearClient() {
      this.show = false;
      this.clientData = "";
    },
  },
};
</script>

<style scoped></style>
